module.exports = __webpack_public_path__ + "img/pro6.b8347ddc.png";